export default {
  grabCursor: true,
  effect: 'coverflow',
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: true,
  },
  loop: true,
  centeredSlides: true,
  pagination: {
    el: '.carousel-navigation',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 7500,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
};
